import { getLocaleMessages } from 'Src/locale'
import { getVideoResolution } from 'Helpers'
import { ValidateSizeVideoPayload, ValidatorOptions, ValidatorResult } from 'Modules'

const messages = getLocaleMessages('ru')

export const validateSizeVideo = async (
	value: File,
	options: ValidatorOptions<ValidateSizeVideoPayload>
) => {
	const validate = new ValidatorResult()
	const { minWidth, minHeight } = options.payload
	try {
		const { width, height } = await getVideoResolution(value)
		if (width < minWidth || height < minHeight) {
			validate.error.message =
				messages[options?.messageError] ||
				messages.errors.min_size_video.replace(':size', `${minWidth}x${minHeight}`)
			validate.error.code = 'bad_format'
		} else {
			validate.result = true
		}
	} catch {
		return validate
	}
	return validate
}
